'use client'

import { Provider } from 'jotai'

export default function Providers({ children }: { children: React.ReactNode }) {
  return <Provider>{children}</Provider>
}
